export const importAll = (r) =>
  r
    .keys()
    .map(r)
    .sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)?.[0] || 0);
      const numB = parseInt(b.match(/\d+/)?.[0] || 0);
      return numA - numB;
    });

// Track Photography
export const trackThumbs = importAll(
  require.context(
    "../componets/img/gallery/Track/tumb",
    false,
    /\.(webp|jpg|png)$/
  )
);

export const trackLarge = importAll(
  require.context("../componets/img/gallery/Track", false, /\.(webp|jpg|png)$/)
);

// Car Shows & Exhibitions
export const showThumbs = importAll(
  require.context(
    "../componets/img/gallery/Show/tumb",
    false,
    /\.(webp|jpg|png)$/
  )
);

export const showLarge = importAll(
  require.context("../componets/img/gallery/Show", false, /\.(webp|jpg|png)$/)
);
